export default "__VITE_ASSET__KtIO8Qdf__"